<div class="app-global-alert">
  <div *ngIf="isErrorAlertVisible" class="global-message-wrapper">
    <div [ngClass]="messageClassName">
      <span id="global-alert" data-automation="global-message">
        {{ message.message }}
      </span>
      <mat-icon class="fill-primary pointer mr-2" (click)="hideBanner()">
        close
      </mat-icon>
    </div>
  </div>
</div>
